/**
 * Глубоко сравнивает два значения.
 * Объекты сравниваются без учёта порядка ключей, а массивы — с учётом порядка элементов.
 */
export function isEqual (left: unknown, right: unknown): boolean {
  // Object.is корректно сравнивает примитивы, одинаковые ссылки и специальные значения вроде NaN.
  if (Object.is(left, right)) return true

  // Если только одно из значений является объектом, они не могут быть равны.
  if (left === null || right === null || typeof left !== 'object' || typeof right !== 'object') {
    return false
  }

  // Даты считаются равными, если совпадает их время в миллисекундах.
  if (left instanceof Date || right instanceof Date) {
    return left instanceof Date &&
      right instanceof Date &&
      left.getTime() === right.getTime()
  }

  // Массивы сравниваются по длине и значениям элементов.
  if (Array.isArray(left) || Array.isArray(right)) {
    return Array.isArray(left) &&
      Array.isArray(right) &&
      left.length === right.length &&
      left.every((value, index) => isEqual(value, right[index]))
  }

  const leftRecord = left as Record<string, unknown>
  const rightRecord = right as Record<string, unknown>
  const leftKeys = Object.keys(leftRecord)
  const rightKeys = Object.keys(rightRecord)

  // Объекты равны, если у них совпадают набор ключей и значения каждого свойства.
  return leftKeys.length === rightKeys.length &&
    leftKeys.every(key =>
      Object.prototype.hasOwnProperty.call(rightRecord, key) &&
      isEqual(leftRecord[key], rightRecord[key])
    )
}
